import { render, staticRenderFns } from "./CurrentTime.vue?vue&type=template&id=8be6c64e"
import script from "./CurrentTime.vue?vue&type=script&lang=js"
export * from "./CurrentTime.vue?vue&type=script&lang=js"
import style0 from "./CurrentTime.vue?vue&type=style&index=0&id=8be6c64e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports